import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StepNavbar from "@Shared/components/general/step-navbar.vue";
import RegistrationSteps from "./registration-steps.vue";
import PageFooter from "@Shared/components/general/page-footer.vue";
import { Fragment } from "vue-fragment";
import { mapActions } from "vuex";
import { CREATE_ACCOUNT, RESEND_CONFIRMATION_CODE, VERIFY_ACCOUNT_EMAIL } from "@Broker/@Modules/main/store/account/account-actions";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RegistrationContainer",
  title() {
    return this.$t("sidebar.sections.registration");
  },
  components: {
    Fragment,
    StepNavbar,
    RegistrationSteps,
    PageFooter
  },
  props: {
    page: {
      type: String,
      default: "personal-details"
    }
  },
  data() {
    return {
      currentPage: this.page,
      creating: {
        loading: false,
        status: true
      },
      verifying: {
        loading: false,
        status: true
      }
    };
  },
  computed: {
    navbarPage() {
      if (this.currentPage === "complete") return "verify";
      return this.currentPage;
    },
    pages() {
      return [{
        label: this.$t("account.registration.tabs.personalDetails"),
        key: "personal-details",
        completed: false
      }, {
        label: this.$t("account.registration.tabs.submit"),
        key: "submit",
        completed: false
      }, {
        label: this.$t("account.registration.tabs.verify"),
        key: "verify",
        completed: false
      }];
    }
  },
  watch: {
    page(val) {
      this.currentPage = val;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [CREATE_ACCOUNT, VERIFY_ACCOUNT_EMAIL, RESEND_CONFIRMATION_CODE])), {}, {
    async handleCreateAccount(accountDetails) {
      this.creating.loading = true;
      this.creating.status = true;
      const result = await this.CREATE_ACCOUNT({
        accountDetails
      });
      this.creating.status = result;
      this.creating.loading = false;
      if (result) {
        this.$router.replace({
          name: "registration-verify"
        });
      }
    },
    async handleVerifyEmail(details) {
      this.verifying.loading = true;
      this.verifying.status = true;
      const result = await this.VERIFY_ACCOUNT_EMAIL(details);
      this.verifying.status = result;
      this.verifying.loading = false;
      if (result) {
        this.$router.replace({
          name: "registration-complete"
        });
      }
    },
    async handleResendCode(details) {
      const result = await this.RESEND_CONFIRMATION_CODE(details);
      if (result) {
        showToast("success", "verificationEmailSent");
      }
    }
  })
});